var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cq-menubarbtn"},[_c('b-button',{staticClass:"mbtn",class:{ 'rightbtn': _vm.rightside,'join': !_vm.last, 'right-border': _vm.curvedend, 'left-border': _vm.curvedfront}},[_vm._v(_vm._s(_vm.menubarbtn))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }